import { Component, inject, OnInit } from '@angular/core';
import { MsalAuthService } from '@app/services/msal-auth/msal-auth.service';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { AppStore } from '@app/stores/app/app.store';
import { SpinnerLoaderComponent } from '../../../../components/spinner-loader/spinner-loader.component';

@Component({
    selector: 'app-client-default',
    imports: [SpinnerLoaderComponent],
    templateUrl: './client-default.component.html',
    styleUrl: './client-default.component.scss',
})
export class ClientDefaultComponent implements OnInit {
    private navigationService = inject(NavigationService);
    private msalAuthService = inject(MsalAuthService);
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;

    ngOnInit(): void {
        this.navigationService.goToClientManagementDefaultPage(
            this.msalAuthService.getDefaultCompanyId(),
        );
    }
}
